<script setup lang="ts">
import ButtonDaisy from '@/components/common/buttons/ButtonDaisy.vue'
import { EnvelopeIcon } from '@heroicons/vue/24/outline'
import { computed } from 'vue'

const props = defineProps({
  email: String,
  tooltipPosition: {
    type: String,
    default: 'top',
  },
  variant: {
    type: String,
    default: 'default',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})
const className = computed(() =>
  !props.disabled ? ' tooltip tooltip-' + props.tooltipPosition : 'tooltip',
)
</script>

<template>
  <div :class="className" :data-tip="email">
    <a
      @click="
        (event) => {
          if (disabled) event.preventDefault()
        }
      "
      :href="'mailto:' + email"
    >
      <ButtonDaisy text="" :icon="EnvelopeIcon" :variant="variant" :disabled="disabled" />
    </a>
  </div>
</template>
